import { combineReducers } from 'redux';

import { authReducer as auth } from './auth';
import { cartReducer as cart } from './cart';
import { commitReducer as commit } from './commit';
import { dialerReducer as dialer } from './dialer';
import { errorReducer as error } from './error';
import { eventsReducer as events } from './events';
import { notificationReducer as notification } from './notifications';
import { officeReducer as offices } from './offices';
import { pointsReducer as points } from './points';
import { storeReducer as store } from './store';
import { userReducer as users } from './users';
import { volunteerReducer as volunteer } from './volunteer';
import { p2aReducer as p2a } from './p2a';
import { amplifyReducer as amplify } from './amplify';
import { reducer as form } from 'redux-form';

const rootReducer = combineReducers({
    auth,
    cart,
    commit,
    dialer,
    error,
    events,
    notification,
    offices,
    points,
    store,
    users,
    volunteer,
    p2a,
    amplify,
    form
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js